var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.163086,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 16.6631H16.25C15.8358 16.6631 15.5 16.9989 15.5 17.4131V30.9131C15.5 31.3273 15.8358 31.6631 16.25 31.6631H32.75C33.1642 31.6631 33.5 31.3273 33.5 30.9131V17.4131C33.5 16.9989 33.1642 16.6631 32.75 16.6631Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 27.913L20.2197 23.1933C20.2893 23.1237 20.372 23.0684 20.463 23.0307C20.554 22.993 20.6515 22.9736 20.75 22.9736C20.8485 22.9736 20.946 22.993 21.037 23.0307C21.128 23.0684 21.2107 23.1237 21.2803 23.1933L25.4697 27.3826C25.5393 27.4523 25.622 27.5075 25.713 27.5452C25.804 27.5829 25.9015 27.6023 26 27.6023C26.0985 27.6023 26.196 27.5829 26.287 27.5452C26.378 27.5075 26.4607 27.4523 26.5303 27.3826L28.4697 25.4433C28.5393 25.3737 28.622 25.3184 28.713 25.2807C28.804 25.243 28.9015 25.2236 29 25.2236C29.0985 25.2236 29.196 25.243 29.287 25.2807C29.378 25.3184 29.4607 25.3737 29.5303 25.4433L33.5 29.413",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 22.2881C27.5392 22.2881 27.875 21.9523 27.875 21.5381C27.875 21.1239 27.5392 20.7881 27.125 20.7881C26.7108 20.7881 26.375 21.1239 26.375 21.5381C26.375 21.9523 26.7108 22.2881 27.125 22.2881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.4a335db89186c4cf6a1f1102fcf6e823.svg";
export { ForwardRef as ReactComponent };